import {
    fetchHeaders,
} from "../../utils/headers";
import Constants from "../../utils/constants";

export const graffitiService = {
    fetchCommunes,
    fetchQuartiers,
    fetchRues,
    fetchMetadata,
    fetchCommuneFeature,
    fetchQuartierFeature,
    fetchRueFeature,
};

function fetchCommunes(clientId) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_GRAFFITI_COMMUNES.replace(':clientId', clientId);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function fetchQuartiers(clientId) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_GRAFFITI_QUARTIERS.replace(':clientId', clientId);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function fetchRues(clientId) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_GRAFFITI_RUES.replace(':clientId', clientId);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function fetchMetadata(clientId) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_GRAFFITI_METADATA.replace(':clientId', clientId);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function fetchCommuneFeature(clientId, id) {
    const requestOptions = fetchHeaders();
    const url = Constants.API_ROUTE_GRAFFITI_COMMUNE_FEATURE
        .replace(':clientId', clientId)
        .replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => data);
}

function fetchQuartierFeature(clientId, id) {
    const requestOptions = fetchHeaders();
    const url = Constants.API_ROUTE_GRAFFITI_QUARTIER_FEATURE
        .replace(':clientId', clientId)
        .replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => data);
}

function fetchRueFeature(clientId, id) {
    const requestOptions = fetchHeaders();
    const url = Constants.API_ROUTE_GRAFFITI_RUE_FEATURE
        .replace(':clientId', clientId)
        .replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(data => data);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}